import { useAuth } from "@/components/AuthProvider";

export function useFetcher() {
  const { isLoggedIn } = useAuth();

  return async function fetcher(url: string) {
    if (!isLoggedIn) {
      return Promise.resolve(null);
    }

    return fetch(url).then((res) => res.json());
  };
}
